import styled from 'styled-components/macro';
import { Icon } from '../../../../../../../../../../UiLibrary';

export default styled(Icon)`
    height: 20px;
`;
